import 'react-toastify/dist/ReactToastify.css';
import '../../index.css';
import '../../tailwind.css';
import 'swiper/css/swiper.min.css';

const LazyLoadCSS = () => {
  return null;
};

export default LazyLoadCSS;
